import { createSlice } from "@reduxjs/toolkit";

const sumUnread = (byConversationId) =>
  Object.values(byConversationId).reduce((sum, count) => sum + count, 0);

export const initialState = {
  byConversationId: {},
  total: 0,
};

export const chatErpUnreadSlice = createSlice({
  name: "chatErpUnread",
  initialState,
  reducers: {
    setConversationUnread: (state, action) => {
      const { conversationId, unreadCount } = action.payload || {};
      if (!conversationId) return;
      if (unreadCount > 0) {
        state.byConversationId[conversationId] = unreadCount;
      } else {
        delete state.byConversationId[conversationId];
      }
      state.total = sumUnread(state.byConversationId);
    },
    replaceFromConversations: (state, action) => {
      const conversations = Array.isArray(action.payload) ? action.payload : [];
      const byConversationId = {};
      conversations.forEach((conv) => {
        const unreadCount = conv?.unreadCount || 0;
        if (conv?.id && unreadCount > 0) {
          byConversationId[conv.id] = unreadCount;
        }
      });
      state.byConversationId = byConversationId;
      state.total = sumUnread(byConversationId);
    },
    clearChatUnread: () => ({ byConversationId: {}, total: 0 }),
  },
});

export const { setConversationUnread, replaceFromConversations, clearChatUnread } =
  chatErpUnreadSlice.actions;

export default chatErpUnreadSlice.reducer;
